import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import axiosInstance from "../utils/axiosInstance";
import "../styles/ForgotPasswordPage.css";

export default function ForgotPasswordPage() {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setSuccessMessage("");
    setErrorMessage("");

    try {
      // ✅ Backend urls.py ile uyumlu endpoint:
      // path("password-reset/request/", views.password_reset_request)
      await axiosInstance.post("/api/auth/password-reset/request/", {
        email: email.trim(),
      });

      setSuccessMessage(t("forgotPassword.successMessage"));
    } catch (error) {
      console.error("Şifre sıfırlama hatası:", error);

      // ✅ Backend farklı formatlarda hata döndürebilir, hepsini yakala:
      const msg =
        error?.response?.data?.detail ||
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        t("forgotPassword.genericError");

      setErrorMessage(msg);
    }
  };

  return (
    <div className="forgot-container">
      <div className="forgot-box">
        <h2 className="forgot-title">{t("forgotPassword.title")}</h2>
        <p className="forgot-description">{t("forgotPassword.description")}</p>

        {successMessage && <div className="forgot-success">{successMessage}</div>}
        {errorMessage && <div className="forgot-error">{errorMessage}</div>}

        <form onSubmit={handleForgotPassword}>
          <label>{t("forgotPassword.emailLabel")}</label>
          <input
            type="email"
            placeholder={t("forgotPassword.emailPlaceholder")}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <button type="submit">{t("forgotPassword.submit")}</button>
        </form>

        <p className="auth-link" style={{ textAlign: "center", marginTop: 12 }}>
          {t("forgotPassword.backToLoginPrefix")} <a href="/login">{t("forgotPassword.backToLoginLink")}</a>
        </p>
      </div>
    </div>
  );
}
